import React , { Component } from 'react';
import Menu from './menu';
import Footer from './footer';
import './App.css';
import {Container,Row,Col} from 'reactstrap';
import services from './img/services.png';import android from './img/android.png';import win from './img/win.png';
import php from './img/php.png';import web from './img/web.png';import desaign from './img/desaign.png';
import js from './img/js.png';
export default class Service extends Component {
  render() {
    return (
      <div>
      <Menu />      
      <Container>
        <Row className="judul-serv text-left">
          <Col sm="8" style={{paddingTop:"50px"}}>
            <h1><b>DONT</b> WORRY</h1><br/>
            <div className="line"/>
            <h4>We Give The Best Service<br/>For Our Client</h4>
          </Col>
          <Col sm="3" align="center">
            <img src={services}/>
          </Col>
        </Row>
        <Row className="card-serv">
          <Col sm="3" align="center">
          <img className="logo-serv" src={win}/><br/>
          <h5>WINDOWS</h5>
          </Col>
          <Col sm="8">
          windows application service,<br/>
          dengan beberapa keahlian C#, VB.NET, .Net Core,
          Entity Framework, Azure, AWS, WPF, WCF,
          XAML, Windows Forms, Windows Workflow Foundation,
          Windows Services, C++, Parallel Programming.
          </Col>
        </Row><br/>
        <Row className="card-serv">
          <Col sm="3" align="center">
          <img className="logo-serv" src={android}/><br/>
          <h5>MOBILE</h5>
          </Col>
          <Col sm="8">
          mobile application service,<br/>
          dengan beberapa keahlian Android - Java, Android - Kotlin,
          iOS - Objective C, iOS - Swift, Xamarin, Ionic, OutSystems,
          React Native, PhoneGap, Cordova, Sencha Touch, Appcelerator Titanium,
          Angular UI, Kendo UI, Intel XDK Framework.
          </Col>
        </Row><br/>
        <Row className="card-serv">
          <Col sm="3" align="center">
          <img className="logo-serv" src={web}/><br/>
          <h5>WEBSITE</h5>
          </Col>
          <Col sm="8">
          web Development service,<br/>
          dengan beberapa keahlian C#, VB.NET, .Net Core, ASP.NET MVC, 
          ASP.NET Web API, Entity Framework, Azure, AWS, SharePoint Development, 
          Office Apps, Kentico, Sitefinity, EPiServer, Sitec className="card-serv"ore, Mintox, jQuery, 
          Web Forms, Windows Workflow Foundation, HTML5, CSS2, JavaScript, AngularJS, 
          Angular, React.
          </Col>
        </Row><br/>
        <Row className="card-serv">
          <Col sm="3" align="center">
          <img className="logo-serv" src={php}/><br/>
          <h5>PHP SERVICE</h5>
          </Col>
          <Col sm="8">
          PHP service,<br/>
          dengan beberapa keahlian Joomla, Drupal, PHP, Moodle, Wordpress, 
          VueJS, EmberJS, Laravel, Symfony, CodeIgniter, CakePHP, Zend, Yii, 
      .
          </Col>
        </Row><br/>
        <Row className="card-serv">
          <Col sm="3" align="center">
          <img className="logo-serv" src={js}/><br/>
          <h5>JAVASCRIPT</h5>
          </Col>
          <Col sm="8">
          Javascript service,<br/>
          dengan beberapa keahlian MongoDB, Express, AngularJS,
          Angular, NodeJS, Loopback, Serverless.
          </Col>
        </Row><br/>
        <Row className="card-serv">
          <Col sm="3" align="center">
          <img className="logo-serv" src={desaign}/><br/>
          <h5>DESIGN UI/UX</h5>
          </Col>
          <Col sm="8">
          Desaign UI/UX service,<br/>
          dengan beberapa keahlian Adobe Photoshop, Adobe Illustrator, Marvel App, 
          Invision, Typeform, Coggle, Moqups, Dreamweaver, HTML.
          </Col>
        </Row><br/>
      </Container>
      <Footer/>      
      </div>
      );
    }
  }


// WEBPACK FOOTER //
// ./src/service.js